module.exports = __webpack_public_path__ + "img/cover.5e9852a1.png";